export default __webpack_public_path__ + "static/media/c002-PPII-11.53870672.svg";